export const FLAG_GETTING_DRIVERS = 'FLAG_GETTING_DRIVERS';
export const GET_DRIVERS = 'GET_DRIVERS';
export const CLEAR_DRIVERS = 'CLEAR_DRIVERS';
export const FLAG_DRIVER_ACTIVITY = 'FLAG_DRIVER_ACTIVITY';
export const GET_DRIVER = 'GET_DRIVER';
export const CLEAR_DRIVER = 'CLEAR_DRIVER';
export const GET_DRIVER_TRIPS = 'GET_DRIVER_TRIPS';
export const CLEAR_DRIVER_TRIPS = 'CLEAR_DRIVER_TRIPS';
